
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b89xc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a5b8b074e57175b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bLLMX = parcelRequire("bLLMX");
class $4a5b8b074e57175b$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    render() {
        const { children: children, localId: localId } = this.props;
        if ((0, $gwFzn.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bLLMX.default), {
            listId: localId,
            children: children
        });
    }
}

});
parcelRegister("bLLMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $453d2759ff34aabb$export$2e2bcd8739ae039);
/* TaskList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $ffCOo = parcelRequire("ffCOo");

var $dh538 = parcelRequire("dh538");

var $fRWmC = parcelRequire("fRWmC");

var $dBxQj = parcelRequire("dBxQj");
const $453d2759ff34aabb$var$listStyles = null;
const $453d2759ff34aabb$var$taskListStyles = null;
const $453d2759ff34aabb$var$TaskListNew = ({ listId: listId, children: children })=>{
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    if (!children) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "group",
        "data-task-list-local-id": "",
        "aria-label": formatMessage((0, $fRWmC.messages).fieldsetLabel),
        className: (0, $35pXk.default)([
            "_2mzuglyw _19bvidpf"
        ]),
        children: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.FabricElementsAnalyticsContext), {
                data: {
                    listLocalId: listId,
                    listSize: listSize,
                    position: idx
                },
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    "data-task-local-id": localId || '',
                    className: (0, $35pXk.default)([
                        "_19pk1b66"
                    ]),
                    children: child
                }, idx)
            });
        })
    });
};
class $453d2759ff34aabb$var$TaskListOld extends (0, $gwFzn.PureComponent) {
    render() {
        const { listId: listId, children: children } = this.props;
        const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.count(children);
        if (!children) return null;
         // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the task.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-task-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            "data-task-list-local-id": "",
            className: (0, $35pXk.default)([
                "_2mzuglyw _19bvidpf"
            ]),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child, idx)=>{
                const { localId: localId } = child.props;
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.FabricElementsAnalyticsContext), {
                    data: {
                        listLocalId: listId,
                        listSize: listSize,
                        position: idx
                    },
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        "data-task-local-id": localId || '',
                        className: (0, $35pXk.default)([
                            "_19pk1b66"
                        ]),
                        children: child
                    }, idx)
                });
            })
        });
    }
}
const $453d2759ff34aabb$var$TaskListNext = (props)=>{
    if ((0, $dh538.fg)('editor_a11y_group_around_action_items')) return /*#__PURE__*/ (0, $7UHDa.jsx)($453d2759ff34aabb$var$TaskListNew, {
        ...props
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($453d2759ff34aabb$var$TaskListOld, {
        ...props
    });
};
var $453d2759ff34aabb$export$2e2bcd8739ae039 = $453d2759ff34aabb$var$TaskListNext;

});
parcelRegister("fRWmC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $01fdfd6ac0ede0b3$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $01fdfd6ac0ede0b3$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    fieldsetLabel: {
        id: "fabric.editor.fieldsetLabel",
        defaultMessage: "Action Item List"
    }
});

});




//# sourceMappingURL=taskList.c13029a1.js.map
